import * as Sentry from '@sentry/react';
import type { ClientEnv } from '@repo/env';

/**
 * Initializes Sentry error tracking.
 * Call this once at app startup, before rendering React.
 * Sentry is silently skipped when VITE_SENTRY_DSN is not set.
 */
export function initSentry(env: Pick<ClientEnv, 'VITE_SENTRY_DSN' | 'MODE'>) {
  if (!env.VITE_SENTRY_DSN) return;

  Sentry.init({
    dsn: env.VITE_SENTRY_DSN,
    environment: env.MODE,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],
    // Lower sample rates in production to control costs
    tracesSampleRate: env.MODE === 'production' ? 0.2 : 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}

export { Sentry };
